import { Action } from "redux";

export const CHANGE_LOWER_LIMIT_ACTION = "CHANGE_LOWER_LIMIT_ACTION";

export interface ChangeLowerLimitAction extends Action {
    lowerLimit: number;
}

export const changeLowerLimitAction = (lowerLimit: number): ChangeLowerLimitAction => ({
    type: CHANGE_LOWER_LIMIT_ACTION,
    lowerLimit: lowerLimit,
});
